/**
 * AlsoOfferSection Component
 * Shows additional Talk Australia services as tag-style cards.
 * Appears in all tiers to cross-sell.
 */

import React from 'react';

const SERVICES = [
  { name: 'Cybersecurity', icon: '\u{1F6E1}\uFE0F', color: '#FF6B6B' },
  { name: 'Cloud Solutions', icon: '\u2601\uFE0F', color: '#5B9DFF' },
  { name: 'CCTV & Security Cameras', icon: '\u{1F4F9}', color: '#FFB347' },
  { name: 'Managed Wi-Fi', icon: '\u{1F4F6}', color: '#00D4AA' },
  { name: 'IoT & Smart Building', icon: '\u{1F3E2}', color: '#C084FC' },
  { name: 'Starlink & Satellite', icon: '\u{1F6F0}\uFE0F', color: '#60A5FA' },
  { name: 'Dash Cams & Fleet', icon: '\u{1F697}', color: '#F472B6' },
  { name: 'Microsoft 365', icon: '\u{1F4BB}', color: '#0078D4' },
  { name: 'VoIP & UCaaS', icon: '\u{1F4DE}', color: '#34D399' },
  { name: 'NBN & Fibre', icon: '\u{1F310}', color: '#FBBF24' },
  { name: 'Mobile Plans', icon: '\u{1F4F1}', color: '#A78BFA' },
  { name: 'Backup & DR', icon: '\u{1F4BE}', color: '#F87171' },
  { name: 'IT Support', icon: '\u{1F6E0}\uFE0F', color: '#38BDF8' },
  { name: 'Print & Copiers', icon: '\u{1F5A8}\uFE0F', color: '#94A3B8' },
];

const styles = {
  section: {
    padding: '60px 20px',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px',
  },
  badge: {
    display: 'inline-block',
    padding: '6px 16px',
    backgroundColor: 'rgba(0, 212, 170, 0.15)',
    color: '#00D4AA',
    borderRadius: '20px',
    fontSize: '13px',
    fontWeight: '600',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    marginBottom: '16px',
  },
  title: {
    fontSize: '32px',
    fontWeight: '700',
    color: '#FFFFFF',
    marginBottom: '12px',
  },
  subtitle: {
    fontSize: '16px',
    color: '#8B92A5',
    maxWidth: '550px',
    margin: '0 auto',
    lineHeight: '1.6',
  },
  tagGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '12px',
  },
  tag: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '12px 20px',
    backgroundColor: '#1A2332',
    borderRadius: '30px',
    border: '1px solid #2A3444',
    fontSize: '14px',
    fontWeight: '500',
    color: '#FFFFFF',
    transition: 'all 0.3s ease',
    cursor: 'default',
  },
  tagIcon: {
    fontSize: '18px',
  },
  cta: {
    textAlign: 'center',
    marginTop: '36px',
  },
  ctaText: {
    fontSize: '15px',
    color: '#8B92A5',
  },
  ctaLink: {
    color: '#0057FF',
    textDecoration: 'none',
    fontWeight: '600',
    marginLeft: '4px',
  },
};

function AlsoOfferSection({ prospect }) {
  return (
    <div style={styles.section}>
      <div style={styles.header}>
        <div style={styles.badge}>One-Stop Shop</div>
        <h2 style={styles.title}>We Also Handle</h2>
        <p style={styles.subtitle}>
          Talk Australia is your single provider for IT, Telco, and Technology.
          Everything under one roof, one bill, one support team.
        </p>
      </div>

      <div style={styles.tagGrid}>
        {SERVICES.map((service) => (
          <div
            key={service.name}
            style={styles.tag}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = service.color;
              e.currentTarget.style.boxShadow = `0 4px 16px ${service.color}22`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = '#2A3444';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <span style={styles.tagIcon}>{service.icon}</span>
            <span>{service.name}</span>
          </div>
        ))}
      </div>

      <div style={styles.cta}>
        <span style={styles.ctaText}>
          Need something not listed?
          <a href="https://talkaustralia.com.au/contact/" style={styles.ctaLink}>
            Ask your Account Manager
          </a>
        </span>
      </div>
    </div>
  );
}

export default AlsoOfferSection;
